/**
 * Creates vuex actions for SSO
 * @param client {LoanOriginationClient}
 * @returns {{logout: logout, login: login, initializeHeartbeat: initializeHeartbeat, stopHeartbeat: stopHeartbeat, initializeSsoSession: initializeSsoSession}}
 */
import { PROCESS_STEP_UPDATED } from '../processStep/types';
import { SET_AUTHENTICATED_USER, SET_INTERVAL, SET_SESSION_ACTIVITY } from './types';

export const actionBuilder = (client) => {
  const login = async ({ rootGetters }, { method = '', originalUrl = window.location.href } = {}) => {
    const loginMethod = method || rootGetters['auth/method'] || '';
    client.publicLogin(originalUrl, loginMethod, rootGetters['ui/language']);

    throw new Error('Login will happen now, all execution flow must stop');
  };

  const logout = ({ rootGetters }) => {
    client.logout(rootGetters['ui/language']);
  };

  const initializeHeartbeat = (store) => {
    if (store.getters.isSessionActive && window.location.pathname !== '/session-expired' ) {
      store.commit(SET_INTERVAL, setInterval(() => {
        client.heartbeat();
      }, 20000));
    }
  };

  const stopHeartbeat = (store) => {
    store.commit(SET_SESSION_ACTIVITY, false);
    store.getters.getIntervalId && clearInterval(store.getters.getIntervalId);
  };

  const prefillApplicant = (store, userdata) => {
    store.commit(`processStep/${PROCESS_STEP_UPDATED}`, { application: { applicant: userdata }}, { root: true });
  };

  const prefillCoBorrower = (store, userdata) => {
    store.commit(`processStep/${PROCESS_STEP_UPDATED}`, { application: { coBorrower: userdata }}, { root: true });
  };

  const initializeSsoSession = async (store) => {
    try {
      const session = await client.checkSession();
      if (session.status === 204) {
        const sso = await client.checkLoginServiceSso();
        if ( sso.status === 200) {
          return store.dispatch('auth/login', {}, { root: true });
        }
      } else {
        const userdata = {
          firstName: session.data.firstName,
          surname: session.data.surname,
          personalIdentityCode: session.data.personalIdentityCode,
        };

        store.commit(SET_AUTHENTICATED_USER, userdata);
        if (session.data.role === 'applicant' || session.data.role === 'authenticatedApplicant') {
          return store.dispatch('prefillApplicant', userdata);
        } else if (session.data.role === 'coApplicant' || session.data.role === 'authenticatedCoApplicant') {
          return store.dispatch('prefillCoBorrower', userdata);
        }
      }
    } catch (err) {
      return false;
    }
  };

  return {
    login,
    logout,
    initializeSsoSession,
    initializeHeartbeat,
    stopHeartbeat,
    prefillApplicant,
    prefillCoBorrower,
  };
};
